export const APP_VERSION = '4.49.0';
